export const SET_TRUSTPILOT = "SET_TRUSTPILOT";

const initialState = {
	rating: 0,
	totalReviews: 0,
};

const trustpilotReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_TRUSTPILOT:
			return {
				rating: action.payload?.rating || 0,
				totalReviews: action.payload?.totalReviews || 0,
			};
		default:
			return state;
	}
};

export default trustpilotReducer;
